<template>
  <footer class="footer">
    <div class="container">
      <Banner />
      <nav class="has-text-weight-semibold is-hidden-touch">
        <a href="http://www.catie.ac.cr" target="_blank" rel="noopener">{{
          $t("commons.catie")
        }}</a>
        &centerdot;
        <router-link :to="{ path: '/download' }">
          {{ $t("menu.download") }}
        </router-link>
        &centerdot;
        <a :href="$localized('shademotion5tutorial')" target="_blank">
          {{ $t("menu.tutorial") }}
        </a>
        &centerdot;
        <router-link :to="{ path: '/documentation' }">
          {{ $t("menu.documentation") }}
        </router-link>
        &centerdot;
        <router-link :to="{ path: '/contact' }">
          {{ $t("menu.contact") }}
        </router-link>
      </nav>
      <p class="has-text-centered-mobile">
        {{ $t("footer.copyright") }} &copy; {{ $t("footer.year") }}
        {{ $t("commons.catie") }} {{ $t("footer.allRights") }}
      </p>
    </div>
  </footer>
</template>
<script>
import Banner from "@/components/Banner.vue";

export default {
  components: {
    Banner
  }
};
</script>
